module.exports = __webpack_public_path__ + "static/media/15-mobile.bc4b8b30.jpg";